<template>
  <div class="studycon  chinese_container">
    <myHeader />
    <!-- 高校专业共建 -->
    <div class="bg1">
      <div class="bg2">
        <div class="cen1">
          <h1 class="wow fadeInUp ProductTitle">
            高校<span class="headtext ProductTitle">专业共建</span>
          </h1>
          <p class="wow fadeInUp TwoProductTitle">企业深度参与课程设计，带来最新行业案例。</p>
          <router-link
            :to="{ name: 'chCaseDemonstration', hash: '#specific-position' }"
            class="setting_a2"
          >
            <button class="wow fadeInUp btn__hover">联系我们</button>
          </router-link>
        </div>
      </div>
    </div>

    <!-- 高校课程升级 -->
    <div class="course-upgrade-container">
      <div class="image-wrapper_contain">
        <h2 class="wow fadeInUp ProductTitle">高校课程<span class="sj">升级</span></h2>

        <img
          src="https://download.hecoos.com/enlightv/2025-16/314262105de87104f5ff41361f536b3e.png" class="wow fadeInUp"
        />
        <p class="description wow fadeInUp">
          对高校原有专业课程进行升级，引入企业端的工作经验、实操教学，形成具有良好基础素养的同时，能够与社会实际工作接轨的高端专业课程。
        </p>
      </div>
    </div>

    <!-- 人才培养目标 -->
    <mySwitch />

    <!-- 课程内容包含 -->
    <div class="course_content">
      <div class="job_test">
        <h2 class="job_title wow fadeInUp ProductTitle">课程内容包含</h2>
      </div>
      <div
        class="course_father"
        v-for="(item, index) in courseItems"
        :key="index"
      >
        <div class="course_contain wow fadeInUp" @click="toggleContent(index)">
          <h2 :class="{ 'show-border': item.isOpen }">{{ item.title }}</h2>
          <div :class="{ active: item.isOpen }">
            <i
              class="el-icon-error"
              :style="{
                transform: item.isOpen ? 'rotate(0deg)' : 'rotate(45deg)',
              }"
            ></i>
          </div>
        </div>
        <div class="course_contain_nei" :class="{ active: item.isOpen }">
          <p>
            {{ item.description }}
          </p>
        </div>
      </div>
    </div>

    <!-- 相关就业方向 -->
    <div class="job-directions-container">
      <div class="job_test">
        <h2 class="job_title wow fadeInUp ProductTitle">相关就业方向</h2>
      </div>
      <div class="job-directions">
        <div class="father_wai" v-for="(item, index) in jobItems" :key="index">
          <div
            class="job_contains wow fadeInUp"
            :class="{ active: item.isOpen }"
            @click="toggleOpen(index)"
          >
            <h2>{{ item.title }}</h2>
            <span
              class="underline"

              :class="{ 'visible': item.isOpen, 'animate-underline': item.isOpen }"
              :style="{ width: item.isOpen? item.underlineWidth + 'px' : '0px' }"
            ></span>
            <div>
              <img
                :src="item.imgSrc"
                alt="图标"
                :class="{ rotate: item.isOpen }"
              />
            </div>
          </div>
          <div class="open_box" :class="{ active: item.isOpen }">
            <p>{{ item.description }}</p>
          </div>
        </div>
      </div>
    </div>

    <!-- 职业技术培训 -->
    <div class="tech-training-wrap">
      <div class="bg-image"></div>
      <div class="text-content">
        <h1 class="wow fadeInUp ProductTitle">职业技术培训</h1>
        <p class="wow fadeInUp">
          以就业为导向的职业技术培训课程，提升学生专业技术能力，提高毕业生在行业内的竞争力。
        </p>
      </div>
    </div>
    <myFooter />
    <BackToTop />
  </div>
</template>

<script>
import BackToTop from "@/components/pc/BackToTop";
import myFooter from "@/components/pc/myFooter.vue";
import myHeader from "@/components/pc/myHeader.vue";
import mySwitch from "@/components/pc/mySwitch.vue";
export default {
  data() {
    return {
      jobItems: [
        {
          title: "01.设计与策划",
          imgSrc:
            "https://download.hecoos.com/enlightv/2025-16/0bebf1e52e3606f516f905db282cec14.PNG",
          description:
            "职责：光影作品艺术设计、交互作品艺术设计、3D Mapping设计、展览展会场景设计与策划",
          isOpen: false,
          underlineWidth: 0,
        },
        {
          title: "02.内容制作",
          imgSrc:
            "https://download.hecoos.com/enlightv/2025-16/0bebf1e52e3606f516f905db282cec14.PNG",
          description:
            "职责：音视频素材制作、剪辑、媒体素材处理、3D Mapping素材制作、交互素材制作",
          isOpen: false,
          underlineWidth: 0,
        },
        {
          title: "03.播控技术工程师",
          imgSrc:
            "https://download.hecoos.com/enlightv/2025-16/0bebf1e52e3606f516f905db282cec14.PNG",
          description: "职责：环境搭建、技术调试、现场播控、设备控制",
          isOpen: false,
          underlineWidth: 0,
        },
        {
          title: "04.预演师",
          imgSrc:
            "https://download.hecoos.com/enlightv/2025-16/0bebf1e52e3606f516f905db282cec14.PNG",
          description: "职责：舞台效果预演、舞台建模",
          isOpen: false,
          underlineWidth: 0,
        },
        {
          title: "05.设计师",
          imgSrc:
            "https://download.hecoos.com/enlightv/2025-16/0bebf1e52e3606f516f905db282cec14.PNG",
          description: "职责：音乐设计、服装设计、场景设计、虚拟场景设计",
          isOpen: false,
          underlineWidth: 0,
        },
        {
          title: "06.导播",
          imgSrc:
            "https://download.hecoos.com/enlightv/2025-16/0bebf1e52e3606f516f905db282cec14.PNG",
          description: "职责：影视拍摄、制作分镜脚本、指挥摄像团队、镜头切换",
          isOpen: false,
          underlineWidth: 0,
        },
        {
          title: "07.编剧与策划",
          imgSrc:
            "https://download.hecoos.com/enlightv/2025-16/0bebf1e52e3606f516f905db282cec14.PNG",
          description: "职责：活动流程管理、编剧、撰写剧本、方案策划",
          isOpen: false,
          underlineWidth: 0,
        },
        {
          title: "08.导演",
          imgSrc:
            "https://download.hecoos.com/enlightv/2025-16/0bebf1e52e3606f516f905db282cec14.PNG",
          description: "职责：导演、执行导演、影视拍摄、工作协调、表演指导",
          isOpen: false,
          underlineWidth: 0,
        },
        {
          title: "09.xR技术工程师",
          imgSrc:
            "https://download.hecoos.com/enlightv/2025-16/0bebf1e52e3606f516f905db282cec14.PNG",
          description: "职责：导演、执行导演、影视拍摄、工作协调、表演指导",
          isOpen: false,
          underlineWidth: 0,
        },
        {
          title: "10.数字交互技术工程师",
          imgSrc:
            "https://download.hecoos.com/enlightv/2025-16/0bebf1e52e3606f516f905db282cec14.PNG",
          description: "职责：交互内容创作、现场设备安装、调试",
          isOpen: false,
          underlineWidth: 0,
        },
      ],
      courseItems: [
        {
          title: "舞台预演系列课程",
          description:
            "·舞台设计、音视频技术、剪辑、乐理、灯光设计、环境搭建、技术调试、现场播控、设备控制、舞台效果预演、舞台建模",
          isOpen: false,
        },
        {
          title: "播控技术3D Mapping系列课程",
          description:
            "·场景设计、视觉效果设计、光影技术原理、交互技术原理、3D Mapping技术原理、LED显示原理、播控技术概论、网络技术、播控软件实操、设备控制技术、灯光控制、同步技术等\n·方案策划、造型、色彩、艺设概论等 \n·媒体素材制作技术、交互技术原理、三维空间设计基础等    ",
          isOpen: false,
        },
        {
          title: "xR虚拟制作系列课程",
          description:
            "·音乐设计、服装设计、场景设计、虚拟场景设计 \n ·文学表达、编剧、方案策划、组织协调、表演艺术、导演、影视制作 \n ·导播、镜头设计、摄影摄像、3D建模、剪辑、音视频技术、分镜制作、团队协调等 \n ·虚拟引擎、LED显示原理、播控技术概论、网络技术、播控软件实操、设备控制技术、xR技术原理、xR调试流程等  ",
          isOpen: false,
        },
        {
          title: "交互艺术装置系列课程",
          description:
            "·数字艺术设计、交互艺术设计、创新设计、视觉表达 \n ·数字艺术的基本概念和原理、交互设计的基本原理和技术、创新思维和技术实施能力 ",
          isOpen: false,
        },
      ],
      switchTexts: [
        "舞台预演系列课程",
        "播控技术3D Mapping系列课程",
        "xR虚拟制作系列课程",
        "交互艺术装置系列课程",
      ],
      currentIndex: 0,
      translateX: 0,
      startX: 0,
      isMoving: false,
      isContentVisible: false,

      imageUrl: 'https://download.hecoos.com/enlightv/2025-17/1505257789b71bf7dc8fa2cb50119bb3.png',

      jobDirections: [
        {
          icon: 'https://download.hecoos.com/enlightv/2025-17/cc93871edf369b73b7214cd432d85db8.png',
          title: "设计与策划",
          description:
            "光影作品艺术设计、交互作品艺术设计、3D Mapping设计、展览展会场景设计与策划",
        },
        {
          icon: 'https://download.hecoos.com/enlightv/2025-17/d6816b5e5b7dc221fb1a34a2ec92ed51.png',
          title: "内容制作",
          description:
            "音视频素材制作、剪辑、媒体素材处理、3D Mapping素材制作、交互素材制作",
        },
        {
          icon: 'https://download.hecoos.com/enlightv/2025-17/9eefc0d5617d430c480648331638ac81.png',
          title: "内容制作",
          description:
            "音视频素材制作、剪辑、媒体素材处理、3D Mapping素材制作、交互素材制作",
        },
        {
          icon: 'https://download.hecoos.com/enlightv/2025-17/479acda74243541f59d06acf7fbfd6f4.png',
          title: "内容制作",
          description:
            "音视频素材制作、剪辑、媒体素材处理、3D Mapping素材制作、交互素材制作",
        },
        {
          icon: 'https://download.hecoos.com/enlightv/2025-17/d6902e850d8fcc764277e462f0b203ac.png',
          title: "内容制作",
          description:
            "音视频素材制作、剪辑、媒体素材处理、3D Mapping素材制作、交互素材制作",
        },
        {
          icon: 'https://download.hecoos.com/enlightv/2025-17/aafde08ad843bce044166d7eb1edb08f.png',
          title: "内容制作",
          description:
            "音视频素材制作、剪辑、媒体素材处理、3D Mapping素材制作、交互素材制作",
        },
        {
          icon: 'https://download.hecoos.com/enlightv/2025-17/dbe10cc7690463a566ce5f974cfaec30.png',
          title: "内容制作",
          description:
            "音视频素材制作、剪辑、媒体素材处理、3D Mapping素材制作、交互素材制作",
        },
        // 依次添加其他就业方向数据
        {
          icon: 'https://download.hecoos.com/enlightv/2025-17/19639819b2d45697eb76ac2c852b8e68.png',
          title: "内容制作",
          description:
            "音视频素材制作、剪辑、媒体素材处理、3D Mapping素材制作、交互素材制作",
        },
        // 依次添加其他就业方向数据
        {
          icon: 'https://download.hecoos.com/enlightv/2025-17/73e84a3548f0856e667397866c9c51fb.png',
          title: "内容制作",
          description:
            "音视频素材制作、剪辑、媒体素材处理、3D Mapping素材制作、交互素材制作",
        },
        // 依次添加其他就业方向数据
      ],
      imageList: [
        { src: 'https://download.hecoos.com/enlightv/2025-17/5c0374f64fde20b7528ddbead941b75d.png' },
        { src: 'https://download.hecoos.com/enlightv/2025-17/5d3666e9d8a3673413a3145f171d4cbd.png', alt: "图片2" },
        { src: 'https://download.hecoos.com/enlightv/2025-17/e98056924545ac8bd5f0f65155938981.png' },
        { src: 'https://download.hecoos.com/enlightv/2025-17/1ea7b11ce611748e4489f6c574837308.png' },
      ],

      courses: [
        {
          title: "舞台预演系列课程",
          description:
            "舞台设计、音视频技术、剪辑、乐理、灯光设计、环境搭建、技术调试、现场播控、设备控制、舞台效果预演、舞台建模",
        },
        {
          title: "播控技术3D Mapping系列课程",
          description: "相关课程介绍内容1舞台设计、音视频技术、剪辑、乐理、灯",
        },
        {
          title: "XR虚拟制作系列课程",
          description: "相关课程介绍内容2灯",
        },
        {
          title: "交互艺术装置系列课程",
          description: "相关课程介绍内容3",
        },
      ],
      selectedIndex: 0,
    };
  },
  computed: {
    selectedCourse() {
      return this.courses[this.selectedIndex];
    },
  },

  // created() {
  //   this.currentImages = this.courseImages[0];
  // },
  mounted() {
    this.calculateUnderlineWidths();
  },
  methods: {
    selectCourse(index) {
      this.selectedIndex = index;
      this.selectedIndex = index;
      // 根据选中的课程索引，更新当前要展示的图片数组
      this.currentImages = this.courseImages[index];
    },
    toggleOpen(index) {
      this.jobItems[index].isOpen = !this.jobItems[index].isOpen;

    },
    calculateUnderlineWidths() {
      this.jobItems.forEach((item, index) => {
        const span = document.createElement("span");
        span.style.visibility = "hidden";
        span.style.whiteSpace = "nowrap";
        span.style.position = "absolute"; // 添加绝对定位
        span.style.fontSize = "32px"; // 设置字体大小为 32px
        span.textContent = item.title;
        document.body.appendChild(span);
        item.underlineWidth = span.offsetWidth;
        document.body.removeChild(span);
      });
    },
    toggleContent(index) {
      this.courseItems[index].isOpen = !this.courseItems[index].isOpen;
    },

    touchStart(event) {
      this.startX = event.touches[0].clientX;
      this.isMoving = true;
    },
    touchMove(event) {
      if (this.isMoving) {
        const moveX = event.touches[0].clientX - this.startX;
        this.translateX += moveX;
        this.startX = event.touches[0].clientX;
      }
    },
    touchEnd() {
      this.isMoving = false;
      const targetIndex = Math.round(-this.translateX / 1000); // 假设图片宽度为300px
      this.currentIndex = Math.min(
        Math.max(targetIndex, 0),
        this.imageList.length - 1
      );
      // 根据当前索引计算位移
      this.translateX = -this.currentIndex * 1000;
    },
    switchImage(index) {
      this.currentIndex = index;
      // 根据点击的索引计算位移
      this.translateX = -index * 1000;
      this.selectedIndex = index;
    },
  },

  components: {
    myFooter,
    myHeader,
    mySwitch,
    BackToTop,
  },
};
</script>

<style scoped lang="scss">
@import "@/styles/wsc.scss";
@import "@/styles/optimize_adaptation.scss";
.setting_a2 {
  text-decoration: none;
  color: #fff;
}
</style>
